<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-body">
        <span>{{'LBL.OPENJOBS_PROPERTY_INFORMATION' | translate}} {{Model}}</span>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary mr-3" (click)="DisableModalOpenEvent = false; c('close')" translate>BTN.BTN_OK</button>
       
    </div>
</ng-template>
